<template>
    <div>
        <page-header
            :show-submit-button="false"

            :can-delete="canDelete"
            :can-create="canCreate"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <div class="grid grid-cols-12 gap-3 mb-2 justify-center">
            <delete-button
                v-if="canDelete"
                btn-class=""
                class="col-start-11 flex flex-col justify-end col-span-1 rounded-lg sm:text-base text-white focus:outline-none"
                :delete-route="route('api.menus.delete', menu.id)"
                value="Delete Menu">
            </delete-button>
        </div>
        <menu-builder
            v-model="menu"
            :language="language"
        >
        </menu-builder>
    </div>
</template>

<script>
import MenuBuilder from "./MenuBuilder";
import crudForm from "../../mixins/crudForm";
import siteLanguage from '../../config/siteLanguage'

export default {
    name: "MenuBuilderPage",
    mixins: [crudForm],
    components: { MenuBuilder },
    props: {
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH, id: siteLanguage.language.ENGLISH };
            },
        },
    },
    data() {
        return {
            menu: {
                id: this.getFormData("id"),
                published_at: this.getFormData("published_at"),
                items: this.getFormData("items", []),
                top_choices: this.getFormData("top_choices", [])
            }
        };
    },
    created() {
       this.menu.baseDocument = this.form.baseDocument;
       this.menu.language = this.form.language;
    }
};
</script>

<style scoped></style>
